import React, { useState, useEffect, useRef } from 'react';
import Loading from '../img//loading.svg';
import Logo from '../img/logo.svg';
import { ReactComponent as StopIcon } from '../img/stop.svg';
import { ReactComponent as ResumeIcon } from '../img/resume.svg';
import { ReactComponent as DeleteIcon } from '../img/delete.svg';
import { Doughnut } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';

const Dashboard = (props) => {

    const [campaigns, setCampaigns] = useState([]);
    const [doughnutData, setDoughnutData] = useState([]);
    const [barsData, setBarsData] = useState([]);
    const [barsLabels, setBarsLabels] = useState([]);
    const [currentSelectedCampaign, setCurrentSelectedCampaign] = useState(-1);
    const [currentCampaignStatus, setCurrentCampaignStatus] = useState('None'); 
    const [currentCampaignQueued, setCurrentCampaignQueued] = useState(0);
    const [currentCampaignDialed, setCurrentCampaignDialed] = useState(0);
    const [loading, setLoading] = useState(false);
    const [idIntervalRefresh, setIdIntervalRefresh] = useState(null);
    const [error, setError] = useState(null);

    const backupCurCmp = useRef(null);

    useEffect(() => {
        //onload execute ....
        getCampaignsDialing();
        startAutoRefresh(3);
    }, []);

    const configDoughnut = {
        labels: ['Conectado','Discando'],
        datasets: [{
            data: doughnutData,
            backgroundColor: (currentCampaignStatus === 'Running') ? ['rgba(42,196,42,0.7)', 'rgba(74,157,240,0.7)'] : ['rgba(136,136,136,0.7)', 'rgba(136,136,136,0.7)'],
            hoverBackgroundColor: (currentCampaignStatus === 'Running') ? ['rgba(42,196,42,1)', 'rgba(74,157,240,1)'] : ['rgba(136,136,136,1)', 'rgba(136,136,136,1)'],
        }]
    };

    let configBars = {
        labels: barsLabels,
        datasets: [
            {
                label: 'Estado llamadas campaña',
                backgroundColor: (currentCampaignStatus === 'Running') ? ['#23D0838C', '#F8C83C8C', '#5E74F38C', '#D023A38C', '#7BBF3C8C', '#EC4F4F8C', '#4BDEDE8C', '#46559C8C', '#B1B9398C', '#D860DA8C', '#7184BB8C', '#5FB73A8C', '#FF78788C', '#606CF98C', '#BD4BA58C', '#64B38B8C', '#CE8B388C'] : ['#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C', '#8888888C'],
                borderColor: (currentCampaignStatus === 'Running') ? ['#23D083C4', '#F8C83CC4', '#5E74F3C4', '#D023A3C4', '#7BBF3CC4', '#EC4F4FC4', '#4BDEDEC4', '#46559CC4', '#B1B939C4', '#D860DAC4', '#7184BBC4', '#5FB73AC4', '#FF7878C4', '#606CF9C4', '#BD4BA5C4', '#64B38BC4', '#CE8B38C4'] : ['#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4'],
                hoverBackgroundColor: (currentCampaignStatus === 'Running') ? ['#23D083C4', '#F8C83CC4', '#5E74F3C4', '#D023A3C4', '#7BBF3CC4', '#EC4F4FC4', '#4BDEDEC4', '#46559CC4', '#B1B939C4', '#D860DAC4', '#7184BBC4', '#5FB73AC4', '#FF7878C4', '#606CF9C4', '#BD4BA5C4', '#64B38BC4', '#CE8B38C4'] : ['#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4', '#888888C4'],
                hoverBorderColor: (currentCampaignStatus === 'Running') ? ['#23D083', '#F8C83C', '#5E74F3', '#D023A3', '#7BBF3C', '#EC4F4F', '#4BDEDE', '#46559C', '#B1B939', '#D860DA', '#7184BB', '#5FB73A', '#FF7878', '#606CF9', '#BD4BA5', '#64B38B', '#CE8B38'] : ['#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888', '#888888'],
                borderWidth: 1,
                data: barsData
            }
        ]
    };


    const optionsBars = { maintainAspectRatio: false, legend: { align: 'start'}}
    const optionsDoughnut = {
        maintainAspectRatio: false, legend: { position: 'bottom' }, 
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        cutoutPercentage: 55  
    }

    const startAutoRefresh = (intervalInSeconds)=>{
        console.log(`Start auto refresh, every ${Number(intervalInSeconds)} seconds ←`);
        let timerId = setInterval(() => getCampaignsDialing(), Number(intervalInSeconds * 1000));
        setIdIntervalRefresh(timerId);
    }

    const stopAutoRefresh = () => {
        clearInterval(idIntervalRefresh);
        console.log('Stop auto refresh ←');
    }


    const pauseCampaign = (selectedCampaign) => {
        setLoading(true);
        setError(null);
        let url = new URL(`${props.config.apiUri}/pauseCampaign`);
        url.search = new URLSearchParams({ idCampaign: selectedCampaign })

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
        })
        .then(res => res.json())
        .then((result) => {
            console.log('result:', result);
            setLoading(false);
        })
        .catch(error => {
            console.error('Error invocacion método pauseCampaign:', error.toString());
            setError('Se produjo un error en la detención de campañas en ejecución');
        })
    }

    const resumeCampaign = (selectedCampaign) => {
        setLoading(true);
        setError(null);
        let url = new URL(`${props.config.apiUri}/resumeCampaign`);
        url.search = new URLSearchParams({ idCampaign: selectedCampaign })

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
        })
        .then(res => res.json())
        .then((result) => {
            setLoading(false);
            console.log('result:', result);
        })
        .catch(error => {
            console.error('Error invocacion método pauseCampaign:', error.toString());
            setError('Se produjo un error en la reanudación de campañas en ejecución');
        })
    }

    const deleteCampaign = (selectedCampaign) => {
        setLoading(true);
        setError(null);
        let url = new URL(`${props.config.apiUri}/deleteCampaign`);
        url.search = new URLSearchParams({ idCampaign: selectedCampaign })

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
        })
        .then(res => res.json())
        .then((result) => {
            setLoading(false);
            console.log('result:', result);
        })
        .catch(error => {
            console.error('Error invocacion método deleteCampaign:', error.toString());
            setError('Se produjo un error en la eliminación de campañas en ejecución');
        })
    }



    const getCampaignsDialing = (currentCampaign = null) => {
        setError(null);

        let selectedCampaign = -1;
        if (currentCampaign){
            selectedCampaign=currentCampaign;
        }else{
            selectedCampaign=Number(backupCurCmp.current.value);
        }
        let url = new URL(`${props.config.apiUri}/campaignsDialing`);

        url.search = new URLSearchParams({
            currentCampaign: selectedCampaign
        })

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
        })
        .then(res => res.json())
        .then((result) => {
            setCampaigns(result.campaigns);
            if (result.campaigns.length > 0){
                selectCampaign(result.campaigns, selectedCampaign); //mantiene valor
            } else {
                setDoughnutData([]);
                setBarsData([]);
            }

            if(result.totalsByStatus){
                configBars.labels=[];
                
                let currentBarsData=[];
                let currentBarsLabels=[];

                result.totalsByStatus.forEach(status => {
                    currentBarsData.push(status.total);
                    currentBarsLabels.push(status.description);
                });

                setBarsData(currentBarsData);
                setBarsLabels(currentBarsLabels);
            }
        })
        .catch(error => {
            console.error('Error invocacion método getCampaignsDialing:', error.toString());
            setError('Se produjo un error en la recuperación de campañas en ejecución');
        })
    }

    const selectCampaign=(campaignList, idCampaign)=>{
        let filteredCampaign = campaignList.filter(campaign => campaign.idCampaign === idCampaign);
        if (filteredCampaign[0]) {
            setDoughnutData([Number(filteredCampaign[0].connected), (Number(filteredCampaign[0].dialing) - Number(filteredCampaign[0].connected)) ]);
            setCurrentCampaignQueued(Number(filteredCampaign[0].queued));
            setCurrentCampaignDialed(Number(filteredCampaign[0].dialed));
            
            Number(filteredCampaign[0].active) === 1 ? setCurrentCampaignStatus('Running') : setCurrentCampaignStatus('Stopped');
        }
    }

    const numericFormatCL=(x)=> {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    return (
        <div className="dashboard">
            <input type="hidden" ref={backupCurCmp} value={currentSelectedCampaign} />

            {error ? (
                <div className="alert error">{error}</div>
            ) : null}

            <div className="flexRow cols6040">
                <div className="flexCol">
                    <div className="card scrollable rel">
                        <h3>Campañas en ejecución</h3>
                        <div className="tableContainer">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="right">#</th>
                                        <th className="right xsHidden">Id</th>
                                        <th className="xsHidden">Cliente</th>
                                        <th>Campaña</th>
                                        <th className="right">Cantidad</th>
                                        <th className="right">Canales</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {campaigns.map((campaign, index) => {
                                        return (
                                            <tr key={campaign.idCampaign} className={(currentSelectedCampaign === campaign.idCampaign) ? 'selected' : null}>
                                                <td className="right">{index + 1}</td>
                                                <td className="right xsHidden">{campaign.idCampaign}</td>
                                                <td className="xsHidden">{campaign.companyName}</td>
                                                <td>{campaign.campaignName}</td>
                                                <td className="right">{numericFormatCL(campaign.totalItems)}</td>
                                                <td className="right">{numericFormatCL(campaign.channels)}</td>
                                                <td><a className="btn" onClick={() => { setCurrentSelectedCampaign(campaign.idCampaign); selectCampaign(campaigns, campaign.idCampaign); getCampaignsDialing(campaign.idCampaign)}}>Ver</a></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="flexCol">
                    <div className="doughnutContainer card">
                        <div className="flexRow cols6040">
                            <div className="flexCol">
                                <Doughnut data={configDoughnut} height={300} width={450} options={optionsDoughnut} />
                            </div>
                            <div className="flexCol infoCampaignWrapper">
                                <div className="centeredWrapper">
                                <p>
                                    <span className="block bold">Estado campaña</span>
                                    <span className="block"><span className={(currentCampaignStatus === 'Stopped') ? 'indicator stopped' : 'indicator running'}></span>{currentCampaignStatus}</span><br/>
                                    <span className="block bold">Números discados</span>
                                    <span className="block">{numericFormatCL(currentCampaignDialed)}</span><br />
                                    <span className="block bold">En cola</span>
                                    <span className="block">{numericFormatCL(currentCampaignQueued)}</span><br />
                                </p>

                                {currentCampaignStatus === 'Running' ? (
                                    <a className="btn controls" onClick={() => pauseCampaign(currentSelectedCampaign)}>Pausar
                                        {loading ? (
                                            <object className="loading" type="image/svg+xml" data={Loading}>svg-animation</object>
                                        ) : <StopIcon className="playIcons"/>}
                                    </a>
                                    ) :  currentCampaignStatus === 'Stopped' ? (
                                    <span>
                                        <a className="btn controls" onClick={() => resumeCampaign(currentSelectedCampaign)}>Reanudar
                                            {loading ? (
                                                <object className="loading" type="image/svg+xml" data={Loading}>svg-animation</object>
                                            ) : <ResumeIcon className="playIcons"/>}
                                        </a><br/>
                                        <a className="btn controls" onClick={() => deleteCampaign(currentSelectedCampaign)}>Eliminar
                                            {loading ? (
                                                <object className="loading" type="image/svg+xml" data={Loading}>svg-animation</object>
                                            ) : <DeleteIcon className="playIcons"/>}
                                        </a>
                                    </span> ): null
                                }
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flexRow twoCols">
                <div className="flexCol">
                    <div className="card">
                        <Bar
                            data={configBars}
                            height={200}
                            options={optionsBars}
                        />
                    </div>
                </div>
                <div className="flexCol">
                    <object className="logo" type="image/svg+xml" data={Logo}></object>
                </div>
            </div>

            {/* <hr />
            <a onClick={() => startAutoRefresh(10)}>INICIAR AUTOREFRESH</a>
            <a onClick={stopAutoRefresh}>DETENER AUTOREFRESH</a>  */}


        </div>
    );
    
}

export default Dashboard;
